import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { Clock } from "lucide-react";
import { CURRICULUM_ITEMS, CURRICULUM_TOTAL_HOURS, CURRICULUM_LEAD } from "../../constants";

export function CurriculumSection() {
  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl text-gray-900">
            モデル研修カリキュラム
          </h2>
          <div className="w-24 h-1 bg-black mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            {CURRICULUM_LEAD}
          </p>
        </div>
        
        <div className="space-y-6 mb-12">
          {CURRICULUM_ITEMS.map((item, index) => (
            <Card key={index} className="border-gray-200 shadow-sm bg-white">
              <CardHeader className="pb-4">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                  <CardTitle className="flex items-start sm:items-center text-lg sm:text-xl text-gray-900">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 bg-black text-white rounded-full flex items-center justify-center mr-3 sm:mr-4 text-xs sm:text-sm flex-shrink-0">
                      {index + 1}
                    </div>
                    <div className="flex-1">
                      <div className="text-sm sm:text-lg text-gray-600">{item.session}</div>
                      <div className="text-base sm:text-xl leading-tight">{item.title}</div>
                    </div>
                  </CardTitle>
                  <div className="flex items-center text-gray-600 self-start sm:self-center">
                    <Clock className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                    <span className="text-xs sm:text-sm">{item.duration}</span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-sm sm:text-base text-gray-700 mb-3 leading-relaxed">{item.description}</p>
                {item.note && (
                  <p className="text-xs sm:text-sm text-gray-600 mb-3 italic leading-relaxed">{item.note}</p>
                )}
                <div className="flex justify-start">
                  <Badge variant="outline" className="border-gray-300 text-gray-600 text-xs sm:text-sm px-2 py-1">
                    {item.structure}
                  </Badge>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        <div className="bg-white p-8 rounded-xl border border-gray-200 text-center">
          <h3 className="text-2xl mb-4 text-gray-900">合計研修時間</h3>
          <div className="text-4xl mb-2 text-black">{CURRICULUM_TOTAL_HOURS}</div>
          <p className="text-gray-600">助成金対象の研修時間を満たします</p>
        </div>
        
        <div className="mt-8 bg-gray-100 p-6 rounded-lg text-center">
          <p className="text-sm text-gray-700">
            ※研修内容は状況により変更になる可能性がございます。
          </p>
        </div>
      </div>
    </section>
  );
}
